import { RequestInputOutputParamsModel } from "../models/requestInputOutputParams.model";
import { HttpService } from "./http.service";

const basePath = "/MonitoringSystem";
const request = HttpService.handleRequest();

export const MonitoringSystemService = {
  getAll
};

async function getAll() {
  return request.get(basePath);
}

export default MonitoringSystemService;